/**
 * @flow
 * Created by neo on 06.06.17.
 */

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import { translate  } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import FlightBookingRequest from '../Store/Booking/FlightBookingRequest';
import BackendFactory from '../Services/BackendFactory';

type Props = {
  booking: FlightBookingRequest,
  isOpen: boolean,
  onCloseRequest: () => void,
  endpoint: string,
};

const RequestingText = (props: any) => {
  const { requesting, request, t } = props;
  if(requesting) {
    return <Alert color="info">{t('Wir verarbeiten gerade Ihre Buchungsanfrage')}</Alert>;
  } else {
    if('REJECTED' === request.status) {
      if (request.error) {
        return <Alert color="danger">{t(request.error)}</Alert>;
      }

      return <Alert color="danger">{t('Leider konnte Ihre Buchung nicht akzeptiert werden. Bitte versuchen Sie einen anderen Zeitraum oder ein anderes Flugzeug')}</Alert>;
    } else if('ACCEPTED' === request.status) {
      return <Alert color="success">{t('Ihre Buchung wurde bestätigt! Sie erhalten in Kürze eine E-Mail mit weiteren Informationen')}</Alert>
    }
  }
};

const RequestingTextUniversal = (props: any) => {
  const { requesting, request, t } = props;
  if(requesting) {
    return <Alert color="info">{t('Processing your order')}</Alert>;
  } else {
    if('REJECTED' === request.status) {
      return <Alert color="danger">{t('Your order could not be processed')}</Alert>;
    } else if('ACCEPTED' === request.status) {
      return <Alert color="success">{t('Your order was processed successfully')}</Alert>
    }
  }
};

const RequestModalFooter = (props: any) => {
  const { requesting, request, onClick, t } = props;
  if(!requesting) {
    return (
      <ModalFooter>
        <Button
          color="primary"
          onClick={onClick}
        >
          {t('Schliessen & Weiter')}
        </Button>
      </ModalFooter>
    );
  }
  return null;
};

@observer
export class ProcessingModal extends Component {

  props: Props;
  state: {
    requesting: boolean,
    request: any,
    interval: any
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      requesting: true,
      request: null,
      interval: null
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    if(!this.props.isOpen && nextProps.isOpen) {
      this.setState({
        requesting: true
      });

      this.request();
    }
  }

  async request() {
    const res = await this.props.booking.send();

    if (res && res.id) {
      this.setState({ request: {
        status: 'ACCEPTED'
      }, requesting: false });

      this.props.onSuccess && this.props.onSuccess(res);
    } else {
      this.setState({ request: {
        status: 'REJECTED',
        error: res ? res.error : null
      }, requesting: false });

      this.props.onError && this.props.onError(res);
    }

  }

  handleClose = () => {
    return this.props.onCloseRequest(this.state.request.status === 'ACCEPTED');
  };

  render() {
    const { t, booking } = this.props;

    const flight = booking.flight || booking.flightOffer;

    return (
      <Modal isOpen={this.props.isOpen}>
        <ModalHeader>
          {
            flight ?
            t('{{name}} Buchung', { name: flight.name }) :
            t('Voucher order')
          }
        </ModalHeader>
        <ModalBody>
          {flight ? <RequestingText
            requesting={this.state.requesting}
            request={this.state.request}
            t={t}
          /> : <RequestingTextUniversal
            requesting={this.state.requesting}
            request={this.state.request}
            t={t}
          />}
          {this.props.children}
        </ModalBody>
        <RequestModalFooter
          requesting={this.state.requesting}
          request={this.state.request}
          onClick={this.handleClose}
          t={t}
        />
      </Modal>
    );
  }
}

export default translate ()(ProcessingModal);



// WEBPACK FOOTER //
// ./src/App/Booking/ProcessingModal.js